import {
  FETCH_TEST_STATUS_COUNT_LOADING,
  FETCH_TEST_STATUS_COUNT_SUCCESS,
  FETCH_TEST_STATUS_COUNT_FAILED,
  SET_SELECTED_TEST_STATUS,
  CLEAR_TEST_STATUS_COUNT
} from "../actionTypeConstants/lambdaTestSidebarTestListConstant";

const initialState = {
  selectedStatus: [],
  statusWiseCount: {
    loading: false,
    data: null,
    error: null
  }
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_TEST_STATUS_COUNT_LOADING:
      return {
        ...state,
        statusWiseCount: {
          ...state.statusWiseCount,
          loading: true
        }
      };

    case FETCH_TEST_STATUS_COUNT_SUCCESS:
      return {
        ...state,
        statusWiseCount: {
          ...state.statusWiseCount,
          loading: false,
          data: action.result.data
        }
      };

    case FETCH_TEST_STATUS_COUNT_FAILED:
      return {
        ...state,
        statusWiseCount: {
          ...state.statusWiseCount,
          loading: false,
          error: action.error
        }
      };

    case SET_SELECTED_TEST_STATUS:
      return {
        ...state,
        selectedStatus: action.payload
      };

    case CLEAR_TEST_STATUS_COUNT: {
      return {
        ...state,
        selectedStatus: [],
        statusWiseCount: {
          ...state.statusWiseCount,
          loading: false,
          data: null,
          error: null
        }
      };
    }

    default:
      return state;
  }
}
